import { createSelector } from '@app/utils/createSelector'
import { getPointArrayKey } from '@app/utils/location'

import type { ApiTimeZone } from '@app/packages/api/v2/types/entities'
import type { Point } from '@app/packages/geo/Point'

import { createReduxSlice } from '@app/store/redux_slice'

const locationTimezonesSlice = createReduxSlice<{ [key: string]: ApiTimeZone }>('location_timezones')

export const setLocationTimezoneSlice = (point: Point, timezone: ApiTimeZone) =>
  locationTimezonesSlice.update(state => ({ ...state, [getPointArrayKey(point)]: timezone }))

export const locationTimezonesGetterSelector = createSelector(
  [locationTimezonesSlice.selector],
  timezones =>
    (point: Point): ApiTimeZone | undefined =>
      timezones?.[getPointArrayKey(point)]
)
